import React from 'react';
import { Badge, Button, Spinner } from 'reactstrap';
import { useQuery } from 'react-query';
import { API } from 'aws-amplify';
import { useHistory } from 'react-router-dom';

export default function NotificationsDisplay({ device }) {
  const history = useHistory();

  const handleClick = () => {
    history.push('/notifications');
  };

  const { data: notificationCount, status } = useQuery(
    'unreadNotificationsCount',
    async () => {
      const response = await API.get('lw-dash', '/notifications/unreadCount');
      return response || 0;
    },
    {
      staleTime: 60000,
    },
  );

  return (
    <>
      {device === 'desktop' ? (
        <Button onClick={handleClick} color="dark" type="button">
          <span>Notifications</span>
          <Badge className="badge-white">
            {status === 'loading' && <Spinner size="sm" />}
            {status === 'success' && notificationCount}
            {status !== 'success' && status !== 'loading' && '-'}
          </Badge>
        </Button>
      ) : (
        <Badge onClick={handleClick} color="primary">{notificationCount}</Badge>
      )}
    </>
  );
}
